module.exports = __webpack_public_path__ + "img/pethouse28.edaf4a5d.jpg";